import { HiddenIcon, ShowIcon } from "@/utils/svgs";
import React, { useState } from "react";
import { FieldError } from "react-hook-form";

interface PasswordInputFieldProps {
  type: "password" ;
  placeholder: string;
  register: any;
  error: FieldError | undefined;
  classes?: string;
}

const FormPasswordInput: React.FC<PasswordInputFieldProps> = ({
  type,
  placeholder,
  register,
  classes,
  error,
}) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [typeState, setTypeState] = useState<string>(type);

  const showPasswordFun = () => {
    
    setShowPassword(prev =>{
      if(!prev){
        setTypeState('text')
      }else{
        setTypeState('password')
      }
      return !prev
    });
   
  };
  return (
    <div className="relative">
      <input
        className={`w-full  rounded-full px-4 py-3 bg-p-gray     focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600 ${classes}`}
        type={typeState}
        autoComplete={false}
        placeholder={placeholder}
        {...register}
      />

        <div>
          <div className="absolute right-2 top-3 cursor-pointer" onClick={showPasswordFun}>
            {showPassword ?  
            <button type="button">
 <ShowIcon /> 
            </button>

           :
           <button type="button" >

             <HiddenIcon /> </button >}
          
          </div>
        </div>
      {error && (
        <p className="text-red-500 text-xs mt-1 py-">{error.message}</p>
      )}
    </div>
  );
};

export default FormPasswordInput;
